"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_rainbow_components_1 = require("react-rainbow-components");
var hooks_1 = require("@rainbow-modules/hooks");
var UniversalForm_1 = __importDefault(require("../UniversalForm"));
var UniversalFormModal = function (props) {
    var isOpen = props.isOpen, onRequestClose = props.onRequestClose, Fields = props.fields, onSubmit = props.onSubmit, title = props.title, initialValues = props.initialValues, submitButtonLabel = props.submitButtonLabel, cancelButtonLabel = props.cancelButtonLabel, rest = __rest(props, ["isOpen", "onRequestClose", "fields", "onSubmit", "title", "initialValues", "submitButtonLabel", "cancelButtonLabel"]);
    var uniqueId = hooks_1.useUniqueIdentifier();
    var footer = (react_1.default.createElement("div", { className: "rainbow-flex rainbow-justify_end" },
        react_1.default.createElement(react_rainbow_components_1.Button, { className: "rainbow-m-right_large", variant: "neutral", onClick: onRequestClose }, cancelButtonLabel),
        react_1.default.createElement(react_rainbow_components_1.Button, { label: "Save", variant: "brand", type: "submit", form: uniqueId }, submitButtonLabel)));
    return (react_1.default.createElement(react_rainbow_components_1.Modal, { title: title, isOpen: isOpen, footer: footer, onRequestClose: onRequestClose },
        react_1.default.createElement(UniversalForm_1.default, { onSubmit: onSubmit, id: uniqueId, initialValues: initialValues },
            react_1.default.createElement(Fields, __assign({}, rest)))));
};
UniversalFormModal.propTypes = {
    /** The title of the Modal */
    title: prop_types_1.default.string,
    /** When `true` the Modal opens */
    isOpen: prop_types_1.default.bool,
    /** Callback that will be invoke when close event. Click on Cancel or Close Button or press ESC. */
    onRequestClose: prop_types_1.default.func,
    /** Callback that will be invoke after on submit event, it will receive an object with all
     * the values of the form already validated.
     */
    onSubmit: prop_types_1.default.func,
    /**
     * Component Class or Function with the fields of your form. Use Field component of react-final-form.
     */
    fields: prop_types_1.default.func,
    /** The initial values of the form e.g. { name: 'Max', age: 30 } */
    initialValues: prop_types_1.default.object,
    /** The label of the submit button on the form */
    submitButtonLabel: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    /** The label of the cancel button on the form */
    cancelButtonLabel: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
};
UniversalFormModal.defaultProps = {
    title: '',
    isOpen: false,
    onRequestClose: function () { },
    onSubmit: function () { },
    fields: function () { return null; },
    initialValues: {},
    submitButtonLabel: 'Submit',
    cancelButtonLabel: 'Cancel',
};
exports.default = UniversalFormModal;
//# sourceMappingURL=index.js.map